import { $, $$ } from '../helpers/selectors';
import { tns } from 'NM/tiny-slider/src/tiny-slider';
import breakpoints from '../helpers/breakpoints';

const $j = jQuery; // eslint-disable-line no-undef
const SELECTOR = '.property-no-image-grid';
const propertyNoImgSections = $$(SELECTOR);
const breakpointMobile = breakpoints.tablet - 1;

class PropertyNoImage {
  constructor() {
    if (! $(SELECTOR)) {
      return false;
    }

    function propertyNoImageCarouselMobile() {
      propertyNoImgSections.forEach(item => {
        const propertyNoImgItems = $j('.property-no-image-grid__item', item);
        const properyNoImgItemContainer = $('.property-no-image-grid__grid-container', item);

        if (propertyNoImgItems.length >= 4) {
          for (let i = 0; i < propertyNoImgItems.length; i += 3) {
            propertyNoImgItems.slice(i, i + 3).wrapAll("<div class='property-no-image-grid__item-mobile'></div>");
          }

          const propertyNoImgCardItems = $$('.card', item);
          propertyNoImgCardItems.forEach(cardItem => {
            $('.card__link', cardItem).setAttribute('tabindex', '-1');
          });

          const propertyNoImgSlider = tns({
            container: properyNoImgItemContainer,
            items: 1,
            slideBy: 'page',
            autoplay: false,
            center: false,
            loop: false,
            controls: false,
            navPosition: 'bottom',
            preventScrollOnTouch: 'force',
            gutter: 20,
            onInit(info) {
              const slideItems = [...info.slideItems];
              tnsTabIndexOnInit(slideItems);
            },
          });

          propertyNoImgSlider.events.on('indexChanged', info => {
            const slideItems = [...info.slideItems];
            tnsTabIndexOnInit(slideItems);
          });
        }
      });
    }

    function tnsTabIndexOnInit(slideItems) {
      slideItems.forEach(item => {
        if (item.classList.contains('tns-slide-active')) {
          item.querySelectorAll('.card').forEach(cardItem => {
            cardItem.querySelector('.card__link-cover').removeAttribute('tabindex');
          });
        } else {
          item.querySelectorAll('.card').forEach(cardItem => {
            cardItem.querySelector('.card__link-cover').setAttribute('tabindex', '-1');
          });
        }
      });
    }

    if (breakpointMobile >= window.outerWidth) {
      propertyNoImageCarouselMobile();
    }
  }
}

export default PropertyNoImage;
